var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sip-file-dropzone",
      class: {
        "is-dragover": _vm.dragover,
        "is-disabled": _vm.disabled,
        "has-file": !!_vm.fileName,
        "has-preview": !!_vm.previewSrc,
      },
    },
    [
      _c("input", {
        ref: "input",
        staticClass: "sip-file-dropzone__input",
        attrs: {
          id: _vm.id || undefined,
          type: "file",
          name: _vm.name || undefined,
          accept: _vm.accept || undefined,
          required: _vm.required,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
        },
        on: {
          change: _vm.onChange,
          dragenter: _vm.onDragEnter,
          dragover: function ($event) {
            $event.preventDefault()
            return _vm.onDragEnter.apply(null, arguments)
          },
          dragleave: _vm.onDragLeave,
          drop: _vm.onDragLeave,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sip-file-dropzone__body" }, [
        _vm.previewSrc
          ? _c("div", { staticClass: "sip-file-dropzone__thumb" }, [
              _c("img", { attrs: { src: _vm.previewSrc, alt: "" } }),
            ])
          : _c(
              "span",
              {
                staticClass: "sip-file-dropzone__icon-wrap",
                attrs: { "aria-hidden": "true" },
              },
              [
                _c("em", {
                  staticClass:
                    "icon ni ni-upload-cloud sip-file-dropzone__icon",
                }),
              ]
            ),
        _vm._v(" "),
        _c("div", { staticClass: "sip-file-dropzone__copy" }, [
          _c("span", { staticClass: "sip-file-dropzone__title" }, [
            _vm._v(_vm._s(_vm.fileName || _vm.buttonLabel)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "sip-file-dropzone__hint" }, [
            _vm._v(_vm._s(_vm.hintText)),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }